module.exports = __webpack_public_path__ + "static/img/right_pic_01.b2586f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right_pic_01.jpg
// module id = MuTX
// module chunks = 1